<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item v-if="user && ![2, 3, 4, 5].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`维保列表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #status="params">
        <span v-if="params.params.settled == 1">已结算</span>
        <span v-if="params.params.settled != 1" style="color:red;">未结算</span>
      </template>
      <template #btns="params">
        <!-- 查看按钮 -->
        <Btn :config="btns[0]" :data="params.params" />
        <!-- 编辑按钮，未结算才显示 -->
        <!-- <Btn v-show="params.params.settled != 1" :config="btns[1]" :data="params.params" /> -->
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FixList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repair',
      breadcrumb: [
        { name: "维保管理", path: `/fix/list` },
        { name: "维保列表", path: `/fix/list` },
      ],
      formCtrl: [
        {
          ...this.ctrls.license,
        },
        {
          label: "维保类型",
          keyName: "article",
          placeholder: "请选择维保类型",
          type: "select",
          options: [],
        },
        {
          label: "结算状态",
          keyName: "settled",
          placeholder: "请选择结算状态",
          type: "select",
          options: [
          { label: '未结算', value: 0},
          { label: '已结算', value: 1 },
          ],
        },
        {
          label: "维保时间",
          keyName: "month",
          placeholder: "请选择",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 90 },
        { prop: "fleet_name", label: "车队长" },
        { prop: "driver", label: "司机" },
        { prop: "article_name", label: "维保类型" },
        { prop: "rstarttime", label: "维保时间", minwidth: 100 },
        { prop: "money", label: "花费金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "mileage", label: "行驶里程", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "settled", label: "结算状态", slot: 'status' },
        { prop: "", label: "操作", slot: 'btns' },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/fix/repairdetail?mode=view&id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/fix/repairdetail?mode=edit&id=${id}`
            );
          },
        },
      ],
      getTotalProperty: ['money'],
    };
  },
  methods: {
    onSearchItemChange({ key }) {
      if (['fleet', 'month', 'article'].includes(key)) {
        this.getList()
      }
    },
    addItem() {
      this.$router.push(`/fix/repairdetail`);
    },
    getOptions() {
      let url = `${this.baseUrl}/getsearch`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ fleet, article }) => {
        this.formCtrl.map(v => {
          if (v.keyName === 'fleet') {
            this.setCtrlOption(v, fleet, 'nickname')
          } else if (v.keyName === 'article') {
            this.setCtrlOption(v, article)
          }
        })
        this.$forceUpdate()
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getOptions();
    const { user_group_id, id } = this.user
    if ([2, 3, 4].includes(user_group_id)) {
      this.btns.length = 1
    } else if (user_group_id == 5) {
      // console.log('222')
      this.btns.length = 1
      this.formInline.fleet = id
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-form--inline .el-form-item:nth-child(6) .el-range-editor.el-input__inner {
  width: 225px;
}
</style>
